<template>
  <div v-scroll="handleScroll">
    <header class="p-businessHeader">
      <div class="p-businessHeaderInner">
        <div class="p-businessHeader_logoWrapper">
          <NuxtLink to="/business/">
            <img
              :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/logo.svg')"
              class="p-businessHeader_logo p-businessHeader_logo-pc"
              alt="ココナラビジネスロゴ"
              width="254"
              height="27"
            >
            <img
              :src="$coconala.fileURL('/staticfiles/images/pages/business/lp/sp/logo.svg')"
              class="p-businessHeader_logo p-businessHeader_logo-sp"
              alt="ココナラビジネスロゴ"
              width="107"
              height="28"
            >
          </NuxtLink>
        </div>
        <ClientOnly>
          <ul class="p-businessHeaderNav">
            <li
              v-if="isDisplayPrivateLink"
              class="p-businessHeaderNav_item p-businessHeaderNav_item-pc"
            >
              <NuxtLink
                class="p-businessHeaderNav_link"
                to="/"
              >
                出品・プライベート購入の方
              </NuxtLink>
            </li>
            <!-- PC時は常に表示 -->
            <li
              v-if="isDisplayCaseLink"
              :class="{ 'p-businessHeaderNav_item-hideTab':  ['PATTERN_A', 'PATTERN_C'].includes(accountPattern) }"
              class="p-businessHeaderNav_item p-businessHeaderNav_item-pc"
            >
              <a
                class="p-businessHeaderNav_link"
                href="https://coconala.com/magazine/case/"
                target="_blank"
                rel="noopener"
              >
                ご利用事例
              </a>
            </li>
            <!-- PC時は常に表示。SP時はPATTERN_A、PATTERN_Cの時に初期表示され、スクロールされるとどの条件でも表示される -->
            <li
              v-if="isDisplayServiceLink"
              :class="[
                { 'p-businessHeaderNav_item-sp': ['PATTERN_A', 'PATTERN_C'].includes(accountPattern) || isOverAccountRegisterButtonPosition },
                { 'p-businessHeaderNav_item-hideTab':  ['PATTERN_A', 'PATTERN_C'].includes(accountPattern) }
              ]"
              class="p-businessHeaderNav_item p-businessHeaderNav_item-pc"
            >
              <!-- CSR遷移だとアンケート未回答の状態でもビジネストップ画面などを閲覧できてしまうため、SSRでnuxtServerInitを通し、アクセス許可対象のwhiteListチェックが必須 -->
              <a
                class="p-businessHeaderNav_link"
                :href="businessTopLink"
              >
                サービスを見てみる
              </a>
            </li>
            <li
              v-if="isDisplayCoconalaLink"
              class="p-businessHeaderNav_item p-businessHeaderNav_item-pc"
            >
              <NuxtLink
                class="p-businessHeaderNav_link"
                to="/"
              >
                ココナラトップへ
              </NuxtLink>
            </li>
            <!-- SPはスクロール時に非表示 -->
            <li
              v-if="isDisplayLoginLink"
              :class="{
                'p-businessHeaderNav_item-pc': accountPattern === 'PATTERN_A' && isOverAccountRegisterButtonPosition,
                'p-businessHeaderNav_item-hideTab': accountPattern === 'PATTERN_A'
              }"
              class="p-businessHeaderNav_item p-businessHeaderNav_item-login"
            >
              <a
                class="p-businessHeaderNav_link p-businessHeaderNav_link-pc"
                href="/business/login"
              >
                ログイン
              </a>
              <!-- sp時に使用 -->
              <DButton
                class="p-businessHeaderNav_loginButton"
                type="outlined"
                color="primary"
                size="small"
                href="/business/login"
                pattern="reverse"
                is-bold
                is-full
              >
                ログイン
              </DButton>
            </li>
            <li
              v-if="isDisplayDownloadLink"
              class="p-businessHeaderNav_item p-businessHeaderNav_item-pc"
            >
              <a
                class="p-businessHeaderNav_link p-businessHeaderNav_link-pc"
                :href="documentDownloadLink"
                target="_blank"
                rel="noopener"
              >
                資料ダウンロード
              </a>
            </li>
            <li
              v-if="isDisplayContactLink"
              class="p-businessHeaderNav_item p-businessHeaderNav_item-pc"
            >
              <DButton
                type="outlined"
                color="primary"
                :href="contactLink"
                pattern="reverse"
                is-bold
                is-full
                target="_blank"
                rel="noopener"
              >
                お問い合わせ
              </DButton>
            </li>
            <!-- PC・SP共にaccountPatternがPATTERN_A、PATTERN_Cのみ表示されるようにし、SP時はスクロールされるまで非表示にする -->
            <li
              v-if="isDisplayRegisterButton"
              :class="{
                'p-businessHeaderNav_item-sp': isDisplayRegisterButton && isOverAccountRegisterButtonPosition,
                'p-businessHeaderNav_item-hideTab': ['PATTERN_A', 'PATTERN_C'].includes(accountPattern)
              }"
              class="p-businessHeaderNav_item p-businessHeaderNav_item-register p-businessHeaderNav_item-pc"
            >
              <DButton
                type="contained"
                color="primary"
                :size="isSP ? 'small' : 'medium'"
                nuxt-link-to="/business/register"
                is-bold
                is-full
              >
                会員登録
              </DButton>
            </li>
          </ul>
        </ClientOnly>
      </div>
    </header>
    <nuxt />
    <slot name="footer">
      <ClientOnly>
        <TheFooter
          ref="footer"
          is-business-footer
        />
      </ClientOnly>
    </slot>
    <TheVueport breakpoint-type="vueportBusinessTop" />
  </div>
</template>

<script>
const VIEW_BUSINESS_LP_ACTION = 'view_business_lp'
import TheFooter from '~/components/organisms/TheFooter'
import TheVueport from '~/components/organisms/TheVueport'
import DButton from '~/components/atoms/DS2/DButton'
import { mapGetters, mapState } from 'vuex'
import { BUSINESS_DOCUMENT_DOWNLOAD_LINK, BUSINESS_CONTACT_LINK } from '~/constants/urls'

export default {
  components: {
    TheFooter,
    TheVueport,
    DButton
  },
  data() {
    return {
      // ヘッダーが会員登録ボタンの表示位置を超えたか判断するフラグ
      isOverAccountRegisterButtonPosition: false
    }
  },
  computed: {
    ...mapState('pages/business/lp', ['accountButtonPosition', 'accountPattern']),
    ...mapGetters('ui', ['isPC', 'isSP']),
    // アカウントの状態によってリンク出し分け
    linkSettings() {
      return {
        DEFAULT: {},
        // 未ログイン
        PATTERN_A: {
          isPrivateLink: true,
          isCaseLink: true,
          isServiceLink: false,
          businessTopLink: '/business/top',
          isLoginLink: true,
          isDownloadLink: true,
          isContactLink: true,
          isCoconalaTopLink: false,
          isRegisterLink: true
        },
        // ビジネスアカウントログイン中
        PATTERN_B: {
          isPrivateLink: false,
          isCaseLink: true,
          isServiceLink: true,
          businessTopLink: '/',
          isLoginLink: false,
          isDownloadLink: false,
          isContactLink: false,
          isCoconalaTopLink: false,
          isRegisterLink: false
        },
        // 個人・出品アカウントログイン中 かつ
        // ビジアカひもづきなし または
        // ビジアカひもづきあり、かつビジアカログイン中セッションなし
        PATTERN_C: {
          isPrivateLink: false,
          isCaseLink: true,
          isServiceLink: true,
          businessTopLink: '/business/top',
          isLoginLink: false,
          isDownloadLink: true,
          isContactLink: true,
          isCoconalaTopLink: true,
          isRegisterLink: true
        },
        // 個人・出品アカウントログイン中 かつ
        // 裏でビジアカログインセッションあり
        PATTERN_D: {
          isPrivateLink: false,
          isCaseLink: true,
          isServiceLink: true,
          businessTopLink: '/business/top',
          isLoginLink: false,
          isDownloadLink: false,
          isContactLink: false,
          isCoconalaTopLink: true,
          isRegisterLink: false
        }
      }
    },
    isDisplayPrivateLink() {
      return this.linkSettings[this.accountPattern]?.isPrivateLink
    },
    isDisplayCaseLink() {
      return this.linkSettings[this.accountPattern]?.isCaseLink
    },
    isDisplayServiceLink() {
      return this.linkSettings[this.accountPattern]?.isServiceLink
    },
    isDisplayLoginLink() {
      return this.linkSettings[this.accountPattern]?.isLoginLink
    },
    isDisplayDownloadLink() {
      return this.linkSettings[this.accountPattern]?.isDownloadLink
    },
    isDisplayContactLink() {
      return this.linkSettings[this.accountPattern]?.isContactLink
    },
    isDisplayCoconalaLink() {
      return this.linkSettings[this.accountPattern]?.isCoconalaTopLink
    },
    isDisplayRegisterButton() {
      return this.linkSettings[this.accountPattern]?.isRegisterLink
    },
    businessTopLink() {
      return this.linkSettings[this.accountPattern]?.businessTopLink
    },
    documentDownloadLink() {
      return BUSINESS_DOCUMENT_DOWNLOAD_LINK
    },
    contactLink() {
      return BUSINESS_CONTACT_LINK
    }
  },
  methods: {
    setOverAccountRegisterButtonPositionFlag(scrollPosition) {
      if (this.isPC) {
        return
      }
      // sp時、スクロール位置がメインカラム内の会員登録ボタンの表示位置を超えた場合にフラグをtrueにする
      this.isOverAccountRegisterButtonPosition = scrollPosition > this.accountButtonPosition
    },
    handleScroll() {
      // IE11ではwindow.scrollYがundefinedになるためpageYOffsetも確認
      const scrollY = window.scrollY || window.pageYOffset
      this.setOverAccountRegisterButtonPositionFlag(scrollY)
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch('big_query/log_action/addLogUserAction', {
        action: VIEW_BUSINESS_LP_ACTION,
        detailJson: JSON.stringify({
          ref: this.$route.query.ref,
          utm_source: this.$route.query.utm_source,
          utm_campaign: this.$route.query.utm_campaign,
          utm_medium: this.$route.query.utm_medium
        })
      })
    } catch (e) {
      this.$sentry.captureException(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.p-businessHeader {
  position: fixed;
  z-index: z(header, main);
  width: 100%;
  height: 72px;
  background: rgba(9, 17, 90, 0.825);

  backdrop-filter: blur(10px);
  &_logoWrapper {
    max-width: 254px;
  }
  &_logo {
    &-sp {
      display: none;
    }
  }
}

.p-businessHeaderInner {
  display: flex;
  overflow: hidden;
  margin: 0 auto;
  padding: 0 16px;
  max-width: 1400px;
  width: 100%;
  height: 100%;

  align-items: center;
}

.p-businessHeaderNav {
  display: flex;
  margin-left: auto;
  column-gap: 20px;

  align-items: center;
  &_link {
    @include link-effect;

    color: $ds2-color-white;
    font-weight: bold;
    font-size: 13px;
  }
  &_loginButton {
    display: none !important;
  }
}

// tablet時のみ
@media (max-width: breakpoint(BusinessTop, M)) and (min-width: breakpoint(BusinessTop, S)) {
  .p-businessHeaderNav_item {
    &-hideTab {
      display: none;
    }
  }
}

// SP
@media (max-width: breakpoint(BusinessTop, S)) {
  .p-businessHeader {
    &_logo {
      &-pc {
        display: none;
      }
      &-sp {
        display: block;
      }
    }
  }

  .p-businessHeaderInner {
    min-width: auto;
  }

  .p-businessHeaderNav {
    &_link {
      &-pc {
        display: none;
      }
    }
    &_item {
      column-gap: 15px;
      &-pc {
        display: none;
      }
      &-sp {
        display: block;
      }
    }
    &_loginButton {
      display: block !important;
    }
  }

  @media (max-width: 360px) {
    .p-businessHeaderNav {
      column-gap: 6px;
      &_item {
        &-login,
        &-register {
          width: 66px;
        }
      }
    }
  }
}
</style>
